import * as React from 'react';

var _path, _path2;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgTron = function SvgTron(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#FC070C",
        fillRule: "evenodd",
        d: "M60 120C27 120 0 93 0 59.701.3 26.701 27-.298 60.3.002c33 .3 59.7 27 59.7 60.6C119.7 93.3 93 120 60 120",
        clipRule: "evenodd"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M102.75 47.306c-1.638-1.512-3.536-3.355-5.514-5.276-2.78-2.698-5.716-5.549-8.307-7.849l-.262-.184a5 5 0 0 0-1.457-.813l-2-.373C71.41 30.236 26.679 21.888 25.759 22a1.8 1.8 0 0 0-.762.289l-.249.197c-.307.312-.54.688-.682 1.102l-.066.17v1.077c3.037 8.456 10.926 27.341 18.21 44.779 6.158 14.742 11.884 28.449 13.88 33.945l.001.002c.263.814.762 2.36 1.693 2.439h.21c.498 0 2.625-2.809 2.625-2.809s38.01-46.095 41.855-51.003a12.5 12.5 0 0 0 1.313-1.943 3.17 3.17 0 0 0-1.037-2.94m-32.38 5.368 16.223-13.453 9.516 8.768zm-34.23-23.77 27.93 22.89L81.33 37.24zm30.45 28.889 28.587-4.607-32.682 39.375zm-4.856-1.667L32.347 31.189l25.135 61.398z",
        clipRule: "evenodd"
    })));
};

export { SvgTron as ReactComponent };
//# sourceMappingURL=Tron.svg.es.js.map
